import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import FounderVision from './components/FounderVision';
import VirtualFactoryTour from './components/VirtualFactoryTour';

const About = () => {
  const navigate = useNavigate();
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    // Update document title
    document.title = 'About Us - Kunjvihari Impex | Premium Fabric Manufacturer & Wholesaler';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription?.setAttribute('content', 
        'Discover Kunjvihari Impex story - 10+ years of fabric manufacturing excellence, delivering premium Polyester, Natural Crepe, Velvet Embroidery, Chinon, and Shimmer fabrics. Leading wholesaler in Surat, Gujarat.'
      );
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <HeroSection />
        
        {/* Founder's Vision */}
        <FounderVision />
        
        {/* Virtual Factory Tour */}
        <VirtualFactoryTour />
        
        {/* Call to Action Footer */}
        <section className="py-12 lg:py-16 bg-gradient-heritage text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-poppins font-bold mb-4 lg:mb-6">
              Ready to Experience Our Quality?
            </h2>
            <p className="text-base lg:text-xl text-white/90 mb-6 lg:mb-8 leading-relaxed">
              Join hundreds of satisfied buyers who trust Kunjvihari Impex for their 
              fabric requirements. Get competitive wholesale prices and premium quality fabrics.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 lg:gap-4 justify-center">
              <button 
                onClick={() => navigate('/contact')}
                className="bg-golden text-primary px-8 py-4 rounded-lg font-semibold hover:bg-golden/90 transition-colors duration-300 flex items-center justify-center space-x-2"
              >
                <span>Get Wholesale Quote</span>
              </button>
              <button 
                onClick={() => navigate('/contact')}
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-primary transition-all duration-300 flex items-center justify-center space-x-2"
              >
                <span>Request Fabric Samples</span>
              </button>
            </div>
          </div>
        </section>
      </main>
      {/* Footer */}
      <footer className="bg-white text-gray-900 py-6 sm:py-8 lg:py-12 border-t-2 border-primary/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 mb-4 sm:mb-6 lg:mb-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center mb-3 sm:mb-4 lg:mb-6">
                <img 
                  src="/assets/images/logo.png" 
                  alt="Kunjvihari Impex" 
                  className="h-[120px] sm:h-[136px] lg:h-[152px] w-auto" 
                />
              </div>
              <p className="text-xs sm:text-sm text-gray-600">
                <span className="font-semibold">GST:</span> 24ABCDE1234F1Z5
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-sm sm:text-base lg:text-lg font-poppins font-semibold text-primary mb-2 sm:mb-3 lg:mb-4">
                Quick Links
              </h3>
              <ul className="space-y-1.5 sm:space-y-2">
                <li>
                  <a href="/" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/about" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/portfolio" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    Portfolio
                  </a>
                </li>
                <li>
                  <a href="/contact" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Our Fabrics */}
            <div>
              <h3 className="text-sm sm:text-base lg:text-lg font-poppins font-semibold text-primary mb-2 sm:mb-3 lg:mb-4">
                Our Fabrics
              </h3>
              <ul className="space-y-1.5 sm:space-y-2">
                <li>
                  <a href="/portfolio" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    Position Print Fabric
                  </a>
                </li>
                <li>
                  <a href="/portfolio" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    Polyester Fabric
                  </a>
                </li>
                <li>
                  <a href="/portfolio" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    Natural Crepe
                  </a>
                </li>
                <li>
                  <a href="/portfolio" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    Velvet Embroidery
                  </a>
                </li>
                <li>
                  <a href="/portfolio" className="text-xs sm:text-sm lg:text-base text-gray-600 hover:text-primary transition-colors font-medium">
                    Chinon & Shimmer
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-sm sm:text-base lg:text-lg font-poppins font-semibold text-primary mb-2 sm:mb-3 lg:mb-4">
                Contact Us
              </h3>
              <div className="space-y-1.5 sm:space-y-2 lg:space-y-3">
                <div className="flex items-start space-x-2">
                  <span className="text-primary mt-0.5">📍</span>
                  <span className="text-[10px] sm:text-xs lg:text-sm text-gray-600 leading-relaxed">
                    115, 116 Shree Darshan Industry Estate, Near Amrut Udhyog Nagar, Kamrej Road, Surat - 395010, Gujarat
                  </span>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-primary">📞</span>
                  <a 
                    href="tel:+919974056700" 
                    className="text-xs sm:text-sm text-gray-600 hover:text-primary transition-colors font-medium"
                  >
                    +91 99740 56700
                  </a>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-primary">✉️</span>
                  <a 
                    href="mailto:info@kunjvihariimpex.com" 
                    className="text-xs sm:text-sm text-gray-600 hover:text-primary transition-colors font-medium"
                  >
                    info@kunjvihariimpex.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-200 pt-4 sm:pt-6 lg:pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-2 sm:gap-4">
              <p className="text-[10px] sm:text-xs lg:text-sm text-gray-500 text-center md:text-left">
                &copy; {new Date()?.getFullYear()} Kunjvihari Impex. All rights reserved.
              </p>
              <p className="text-[10px] sm:text-xs lg:text-sm text-gray-500 font-medium">
                Precision in Every Thread
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default About;